<template>
    <v-container>
        <v-row>
            <v-col
                v-for="(item, i) in menuItemsPermissions"
                :key="i"
                cols="12"
                sm="6"
                md="4"               
            >
                <v-card
                    class="mod-card rounded-xl"
                    elevation="0"
                    @click="display(item.option)"
                    max-width="300"
                >
                    <v-card-text class="mod-card__body">
                        <div class="mod-card__icon mb-3" :style="{ background: item.bg }">
                            <v-icon :color="item.color" size="23">{{ item.icon }}</v-icon>
                        </div>
                        <p class="mod-card__title">{{ item.title }}</p>
                        <p class="mod-card__sub">{{ item.subtitle }}</p>
                    </v-card-text>
                    <div class="mod-card__accent" :style="{ background: item.color }" />
                </v-card>
            </v-col>    
        </v-row>
    </v-container>    
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    name: 'MainMenu',

    created(){
        this.initialize();
    },

    data: () => ({
        menuItems: [
            {
                icon:  'mdi-pencil',
                title: 'Enter Marks ',
                subtitle: 'Subject Teachers',
                color: '#1565C0',
                bg: '#E3F2FD',
                src: require("../assets/icons/enter-marks.png"),
                option: 'markSheet',
                display: false
            },
            {
                title: 'Edit/View Term Details ',
                subtitle: 'Form Teachers',
                src: require('../assets/icons/term-reports.png'),
                option: 'termDetails',
                icon:  'mdi-calendar-edit',
                color: '#6A1B9A',
                bg: '#F3E5F5',
                display: false
            },
            {
                title: 'Print/View Reports',
                subtitle: 'Report Cards, Mark Sheets...',
                src: require('../assets/icons/print-view-reports.png'),
                option: 'reports',
                display: false,
                icon:  'mdi-printer',
                color: '#00695C',
                bg: '#E0F2F1',
            },
            {
                icon:  'mdi-account-group',
                color: '#BF360C',
                bg:'#FBE9E7',
                title: 'Employees',
                subtitle: 'Add / Edit Teachers, Timetables',
                src: require('../assets/icons/teacher.png'),
                option: 'employees',
                display: false
            },
            {
                icon:  'mdi-clipboard-list',
                color: '#2E7D32',
                bg:  '#E8F5E9',
                title: 'Subject Student Assignment',
                subtitle: 'Assign Students to Subjects',
                src: require('../assets/icons/subject-assignment.png'),
                option: 'subjects',
                display: false
            },
            {
                icon:  'mdi-account-school',
                color: '#283593',
                bg:'#E8EAF6',
                title: 'Students',
                subtitle: 'View/Edit Student Records',
                src: require('../assets/icons/edit-view-students.png'),
                option: 'students',
                display: false
            },           
            {
                icon:  'mdi-lock-reset',
                color: '#B71C1C',
                bg: '#FFEBEE',
                title: 'Reset Password',
                subtitle: 'Employee Passwords',
                src: require('../assets/icons/reset-password.png'),
                option: 'resetPassword',
                display: false
            },   
                   
            {
                icon:  'mdi-cog',
                color: '#37474F',
                bg: '#ECEFF1',
                title: 'Settings',
                subtitle: 'System Configuration',
                src: require('../assets/icons/settings.png'),
                option: 'settings',
                display: false
            }, 
           
        ],
        menu: '',  
    }),

    computed: {
        ...mapGetters({
            user: 'auth/getUser',
            menuOptions: 'mainMenu/getMenuOptions',                     
        }),

        menuItemsPermissions () {
            return this.menuItems.filter(item => item.display)
        }
        
    },
   
    methods: {
        ...mapMutations({            
            setWelcomeMessage: 'mainMenu/setWelcomeMessage',            
            setAdmin: 'auth/setAdmin',
            setEditTermReport: 'auth/setEditTermReport',                                              
        }),

        initialize () {   
            let userPermissions = JSON.parse(sessionStorage.getItem('permissions'));
            let user = JSON.parse(this.user);

            if(user.employee_id !== 'Admin'){
                this.menuItems.forEach(item => {
                    item.display = userPermissions.some(permission => permission.value == item.option);
                })
                return;
            }

            this.menuItems.forEach(item => {
                item.display = true;
            })
            
        },
        
        display (menu) {
            this.setWelcomeMessage(false);
            Object.keys(this.menuOptions).forEach(key => {
                if(key == menu) this.menuOptions[key] = true;
                else this.menuOptions[key] = false;
            })
        }

    }
}
</script>

<style scoped>
 .v-card__title{
    word-break: break-word;
    text-align: center;
 }

 /* ── Module Card ─────────────────────────────────────────────── */
.mod-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  background: white !important;
  cursor: pointer;
  overflow: hidden !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
 
.mod-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(26, 35, 126, 0.13) !important;
}
 
.mod-card__body {
  padding: 18px 18px 14px !important;
}
 
.mod-card__icon {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.mod-card__title {
  margin: 0 0 3px;
  font-weight: 600;
  font-size: 1rem;
  color: #1A1A2E;
  line-height: 1.35;
}
 
.mod-card__sub {
  margin: 0;
  font-size: 11.5px;
  color: #9E9E9E;
  line-height: 1.4;
}
 
.mod-card__accent {
  height: 3px;
  opacity: 0.75;
}
</style>